export const CHATBOT_DEFAULT_BOTTOM_OFFSET = 15;
export const CHATBOT_DEFAULT_RIGHT_OFFSET = 15;
export const CHATBOT_SMALL_VIEW_MAX_WIDTH = 1200;
